<div class="d-flex justify-content-center" style="height: 100vh; width: 100%; background-image: url('assets/bg.jpg'); background-repeat: no-repeat; background-size: cover;">

    <div class="col-12 col-md-6 mx-auto align-self-center">
        <div class="card">
            <div class="card-body">
                <div class="text-center mb-3">
                    <img src="assets/logo.png" class="img-fluid" alt="" style="height: 80px;">

                </div>
                <h6>
                    <div class="mb-3">Mot de passe oublié?</div>
                    <span>Renseignez votre email pour définir un nouveau mot de passe .</span>
                    </h6>
                    
                    <div *ngIf="!mailSent">
                        <form class="" #fpForm="ngForm" (ngSubmit)="sendMail(fpForm.value)">
                            <div class="form-row">
                    <div class="col-md-12">
                    <div class="position-relative form-group">
                    <label for="exampleEmail" class="">Email</label>
                    <input name="email" id="exampleEmail" placeholder="Email ici..." type="email" class="form-control" ngModel required>
                    </div>
                    </div>
                    </div>
                    <div class="mt-4 d-flex align-items-center">
                    <h6 class="mb-0">
                    <a routerLink="/admin/login" class="text-primary">Je dispose déjà d'un compte</a>
                    </h6>
                    <div class="ml-auto">
                    <button class="btn btn-primary btn-lg" [disabled]="fpForm.invalid || loading" type="submit">Récupérer <app-loading [isVisible]="loading"></app-loading></button>
                    </div>
                    </div>
                    </form>
                    </div>
                    
                    <div  *ngIf="mailSent">
                        <div class="text-center">
                            <img src="assets/template2/images/success.png" alt="">
                        </div>
                        <p class="text-primary">Un mail de récupération de votre mot de passe vous a été transféré ! Veuillez consulter votre boîte mail. <br> Merci</p>
                    </div>
            </div>
        </div>
    </div>
</div>

